import styled from 'styled-components';

export const StyledLoginWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .logo {
    margin-bottom: 15px;
  }
  .google-auth-btn {
    margin: 15px 0;
    padding: 0;
    width: 40px;
    height: 40px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
`;

export const StyledLoginFormHead = styled.div`
  padding-bottom: 15px;
  text-align: center;
  p {
    text-align: center;
  }
`;

export const StyleFormTitle = styled.div`
  color: ${({theme}) => theme.text.primary};
  font-size: 16px;
`;

// Крок 2FA лишається на тому ж роуті, тому "назад" тут кнопка, а не посилання.
// Стилі повторюють глобальні правила для <a>, щоб виглядати так само як "Забули пароль?"
export const StyledLoginBackButton = styled.button`
  color: inherit;
  font: inherit;
  border: none;
  transition: all .3s ease;
  &:hover {
    color: ${({theme}) => theme.link.hover};
  }
`;

export const StyledLoginFormWrapper = styled.div`
  max-width: 445px;
  width: 100%;
  margin-bottom: 35px;
  padding: 25px;
  background-color: ${({theme}) => theme.surface.background};
  border: 1px solid ${({theme}) => theme.surface.border};
  border-radius: 5px;
  .login-with-google {
    text-align: center;
    //border: 1px dashed red;
    &__button {
      //background-color: orange;
      //margin: 20px 0;
      padding: 0;
      width: 40px;
      height: 40px;
      color: ${({theme}) => theme.text.primary};
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      border: 2px solid ${({theme}) => theme.text.primary};
      transition: all .3s ease;
      &:hover {
        background-color: ${({theme}) => theme.overlay.accentSoft};
      }
    }
    &__text {
      padding: 15px 0;
      text-align: center;
    }
  }
  .login-form {
    padding: 0;
    border: none;
    box-shadow: none;
    &__action {
      padding-top: 15px;
      justify-content: center;
      text-align: center;
      grid-gap: 10px;
    }
    &__hint {
      color: #6f7a8f;
      font-size: 13px;
    }
    &__input, .twofa-field-group {
      & > div {
        padding: 3px 0;
      }
      label {
       font-size: 14px;
       font-weight: 600;
      }
      input {
        font-size: 14px;
      }
      span {
        font-size: 14px;
      }
    }
    .twofa-field-group {
      margin-bottom: 25px;
    }
  }
  @media screen and (max-width: 600px) {
    padding: 20px 15px;
  }
`;
